
import { env } from '@env';
import { HttpRequestData, httpUtil, PaginationResponse } from '@/framework';

export interface GetRevenueOfStaffDetailRequest extends HttpRequestData {
    readonly query: {
        readonly salonId: number;
        readonly startDate: string;
        readonly endDate: string;
        readonly objectType?: "SERVICE" | "PRODUCT";
        readonly staffId: number;
    }
}

export interface GetRevenueOfStaffDetailResponse  {
    readonly totalRevenue?: number;
    readonly totalQuantity?: number;
    readonly salonBranchId?: number;
}

export const getRevenueOfStaffDetail = httpUtil.createHttpRequestMeta<
    GetRevenueOfStaffDetailRequest,
    PaginationResponse<GetRevenueOfStaffDetailResponse>
>({
    baseUrl: env.orgServer,
    path: '/revenues/staff-detail',
    method: 'GET',
    authentication: 'bearer'
});
